<template>
    <svg xmlns="http://www.w3.org/2000/svg" class="e3-svg" :width="Number(size)" :height="Number(size)" viewBox="0 0 24 24">
        <path fill="currentColor" d="M10 4v3h2.21l-3.42 8H6v3h8v-3h-2.21l3.42-8H18V4h-8z"/>
    </svg>
</template>

<script>
export default {
    name: 'FormatItalicIcon',
    props: {
        size: {
            type: [String, Number],
            default: 24
        }
    }
};
</script>
